import React, { useState } from 'react';
import { Row, Col, ProgressBar } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { motion } from 'framer-motion';
import "./index.scss";

import GaugeChart from 'react-gauge-chart'

import ProfileAvatar from "../../../../components/ui/ProfileAvatar";
import SkeletonLoader from "../../../ui/SkeletonLoader/index.js";

import ScanModal from "../../Domain/ScanModal";
import DeleteScanModal from "../../ScanQueue/DeleteScanModal";

import { domainTileViewScanStartIcon, domainTileViewDeleteScanIcon, domainTileViewPauseIcon } from "../../../../utils/icons.js";
import { formatDate, formatNumber, getDomainImageUrl } from "../../../../utils/util";

import { useDispatch } from 'react-redux';
import { stopScanSingle, resumeScanSingle } from "../../../../store/actions/scanqueueAction.js";

const DomainTileView = ({ domainList, isLoading }) => {

    const dispatch = useDispatch();

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [scanningDomain, setScanningDomain] = useState(null);
    const [showStartScanModal, setShowStartScanModal] = useState(false); // Modal visibility state
    const [showdeleteScanModal, setShowdeleteScanModal] = useState(false);
    const [deleteDomainData, setDeleteDomainData] = useState(null)

    const handleStartScan = (data) => {
        setScanningDomain(data);
        setShowStartScanModal(true); // Open the modal
    };

    const handleViewDetailsClick = (data) => {
        navigate(`/domain/details/${data.domain}`); // Replace '/details' with your target route
    };

    const handleCloseModal = () => setShowStartScanModal(false); // Close modal function

    const handleCloseDeleteDomainModal = () => setShowdeleteScanModal(false);

    const formatCreatedDate = (data) => {
        let date = formatDate(data.created_at)
        return `Created On : ${date}`
    }

    const totalNewFindings = (data) => {
        let {asset_discovery, external_detected_vulnerabilities, darkweb, concerning_exposures } = data
        return formatNumber(asset_discovery + external_detected_vulnerabilities + darkweb + concerning_exposures)
    }

    const getMeterPercent = (data) => {
        const result = (data?.stats?.score?.latest_score?.overall_score?.obtained_score / data?.stats?.score?.latest_score?.overall_score?.max_score);
        return result
    }

    const chartStyle = {
        height: 50,
        width: 100,
    }

    const updateScan = (data, type) => {
        let obj = {
            scan_id : data?.scan_queue_detail?.scan_id
        }
        if( type === "stop") {
            dispatch(stopScanSingle(obj))
        }
        if( type === "resume") {
            dispatch(resumeScanSingle(obj))
        }
        if(type === "delete") {
            setDeleteDomainData(data)
            setShowdeleteScanModal(true)
        }
    }

    return (
        <Row>          
            {
                isLoading ?
                    <Col xl="12" lg="12" md="12" className="mt-4">
                        <div className="domain-container p-4 rounded h-100">
                            <SkeletonLoader type={"line"} count={4} currentPage={"domains"} />
                        </div>
                    </Col>                    
                :
                <>
                    {
                        domainList?.results.length > 0 && 
                        domainList?.results.map((data, index)=>{
                            return (
                                <Col xl="6" lg="12" md="12" className="mt-4 col-xxxl-4" key={index}>
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        // whileInView={{ opacity: 1, y: 0 }}
                                        // viewport={{ once: true }}
                                        transition={{ duration: 0.4, delay: index * 0.1 }}
                                    >
                                        <div className="domain-container p-4 rounded h-100">
                                            <div className="organization-profile">
                                                <div className="organization-profile-header d-flex justify-content-between">
                                                    <div className="organization-details">
                                                        <ProfileAvatar pageType={"domainHomePage"} type="domain" name={data?.domain} imageUrl={getDomainImageUrl(data)} secondaryText={formatCreatedDate(data)}/>
                                                    </div>
                                                    <div className="organization-actions">
                                                        <button
                                                            className={`view-details-btn ${(data?.scan_queue_detail?.scan_status === "in_progress" || data?.scan_queue_detail?.scan_status === "pending" || data?.scan_queue_detail?.scan_status === "stopped" || data?.scan_queue_detail?.scan_status === "in_queue") ? "disabled-btn" : ""}`}
                                                            onClick={() => handleStartScan(data)}
                                                            disabled={(data?.scan_queue_detail?.scan_status === "in_progress" || data?.scan_queue_detail?.scan_status === "pending" || data?.scan_queue_detail?.scan_status === "stopped" || data?.scan_queue_detail?.scan_status === "in_queue")}
                                                        >
                                                            <span className="icon">{domainTileViewScanStartIcon()}</span>
                                                            {t("domainPage.startScanBtn")}
                                                        </button>
                                                        <button className="view-scan-btn" onClick={()=>{handleViewDetailsClick(data)}}>{t("organizationPage.viewDetailsBtn")}</button>
                                                    </div>
                                                </div>
            
                                                <div className="my-3">
                                                    <div className="d-flex justify-content-between">
                                                        {data?.scan_queue_detail?.scan_status === "new" && <p className="scan-status-text"><span>{t("domainPage.scanStatus")}:</span> Yet to Start</p>}
                                                        {data?.scan_queue_detail?.scan_status === "in_progress" && <p className="scan-status-text"><span>{t("domainPage.scanStatus")}:</span> {`${data?.scan_queue_detail?.scan_percentage}%`}</p>}
                                                        {data?.scan_queue_detail?.scan_status === "pending" && <p className="scan-status-text"><span>{t("domainPage.scanStatus")}:</span> {`Pending - ${data?.scan_queue_detail?.scan_percentage}%`}</p>}
                                                        {data?.scan_queue_detail?.scan_status === "in_queue" && <p className="scan-status-text"><span>{t("domainPage.scanStatus")}:</span> {`In Queue - ${data?.scan_queue_detail?.scan_percentage}%`}</p>}
                                                        {data?.scan_queue_detail?.scan_status === "stopped" && <p className="scan-status-text"><span>{t("domainPage.scanStatus")}:</span> {`Stopped - ${data?.scan_queue_detail?.scan_percentage}%`}</p>}
                                                        {data?.last_scan_detail?.created_at !== null && <p className="scan-status-text"><span>{t("domainPage.lastScan")}:</span> {formatDate(data?.last_scan_detail?.created_at)}</p>}
                                                    </div>                                        
                                                    <div
                                                        className={`${data?.scan_queue_detail?.scan_status === "in_progress" ? "scan-progress my-3" : "my-3"}`}
                                                        style={{ display: 'flex', alignItems: 'center', minHeight: '35px' }}
                                                    >
                                                        <ProgressBar
                                                            now={data?.scan_queue_detail?.scan_status === "in_progress" || data?.scan_queue_detail?.scan_status === "pending" || data?.scan_queue_detail?.scan_status === "stopped" || data?.scan_queue_detail?.scan_status === "in_queue" ? data?.scan_queue_detail?.scan_percentage : 0}
                                                            style={{ height: '8px', width: '100%' }}
                                                            className={`custom-progress-bar ${data?.scan_queue_detail?.scan_status === "pending" || data?.scan_queue_detail?.scan_status === "stopped" || data?.scan_queue_detail?.scan_status === "in_queue" ? 'paused-progress' : ''}`} // Add conditional class
                                                        />
            
                                                        { data?.scan_queue_detail?.scan_status === "in_progress" && 
                                                            <>
                                                                <button className="view-details-btn-scan" onClick={()=>{updateScan(data, 'stop')}}>
                                                                    {domainTileViewPauseIcon()}
                                                                </button>
                                                                <button
                                                                    className="view-details-btn-trash disabled-btn-grey"
                                                                    disabled={true}
                                                                >
                                                                    {domainTileViewDeleteScanIcon()}
                                                                </button>
                                                            </>
                                                        }
                                                        { data?.scan_queue_detail?.scan_status === "pending" && 
                                                            <>
                                                                <button className="view-details-btn-scan" onClick={()=>{updateScan(data, 'stop')}}>
                                                                    {domainTileViewPauseIcon()}
                                                                </button>
                                                                <button className="view-details-btn-trash disabled-btn-grey" disabled={true}>
                                                                    {domainTileViewDeleteScanIcon()}
                                                                </button>
                                                            </>
                                                        }
                                                        { data?.scan_queue_detail?.scan_status === "in_queue" && 
                                                            <>
                                                                <button className="view-details-btn-scan" onClick={()=>{updateScan(data, 'stop')}}>
                                                                    {domainTileViewPauseIcon()}
                                                                </button>
                                                                <button className="view-details-btn-trash disabled-btn-grey" disabled={true}>
                                                                    {domainTileViewDeleteScanIcon()}
                                                                </button>
                                                            </>
                                                        }
                                                        { data?.scan_queue_detail?.scan_status === "stopped" && 
                                                            <>
                                                                <button className="view-details-btn-scan" onClick={()=>{updateScan(data, 'resume')}}>
                                                                    <span className="icon">{domainTileViewScanStartIcon()}</span>
                                                                </button>
                                                                <button className="view-details-btn-trash" onClick={()=>{updateScan(data, 'delete')}}>
                                                                    {domainTileViewDeleteScanIcon()}
                                                                </button>
                                                            </>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
            
                                            {/* Domain Findings and Ratings Section */}
                                            <div className="organization-findings">
                                                <Row>
                                                    <Col md="6">
                                                        <div className="total-domains h-100">
                                                            <div className="total-domains-container rounded p-3 h-100">
                                                                <h2>{t("domainPage.riskRatings")}</h2>
                                                                <div className="d-flex border-bottom">
                                                                    <div className="gauge-container">
                                                                        <GaugeChart 
                                                                            id="gauge-chart1"
                                                                            nrOfLevels={4} 
                                                                            colors={["#ee6862", "#f2a16b", "#F4DA6B", "#8dd761"]}
                                                                            percent={getMeterPercent(data)}
                                                                            arcWidth={0.2}
                                                                            arcPadding={0}
                                                                            cornerRadius={0}
                                                                            hideText={true}
                                                                            style={chartStyle}
                                                                        />
                                                                    </div>
                                                                    <div className="align-items-center">
                                                                        <div className="hacker-sec mb-2">
                                                                            <h5>{data?.stats?.score?.latest_score?.overall_score?.obtained_score}<span className="overall-score">/{data?.stats?.score?.latest_score?.overall_score?.max_score}</span></h5>
                                                                            <p>Hacker Score</p>
                                                                        </div>
                                                                    </div>
                                                                </div>                                                    
                                                                
                                                                <div className="domain-align d-flex align-items-center justify-content-between mt-4 mb-3">
                                                                    <div className='domain-bottom'>
                                                                        <div>
                                                                            <h2>{data?.stats?.score?.latest_score?.infrastructure_score?.obtained_rating}</h2>
                                                                            <p>{t('domainPage.infrastructure')}</p>
                                                                        </div>
                                                                        <div className='domain-sec'>
                                                                            <h2>{data?.stats?.score?.latest_score?.exposure_score?.obtained_rating}</h2>
                                                                            <p>{t('domainPage.exposure')}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <h2>{data?.stats?.score?.latest_score?.vulnerability_score?.obtained_rating}</h2>
                                                                            <p>{t('domainPage.vulnerabilities')}</p>
                                                                        </div>
                                                                        <div className='domain-sec'>
                                                                            <h2>{data?.stats?.score?.latest_score?.darkweb_score?.obtained_rating}</h2>
                                                                            <p>{t('domainPage.darkWeb')}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="new-findings-container h-100">
                                                            <div className="new-findings-list rounded p-3 h-100">
                                                                <h2>{t("domainPage.totalFindings")}</h2>
                                                                <h4 className="m-0">{totalNewFindings(data?.stats?.new_findings)}</h4>
                                                                <p>{t("organizationPage.newFindings")}</p>
                                                                <div className="finding-list">
                                                                    <ul className="m-0 p-0">
                                                                        <li className="d-flex justify-content-between">
                                                                            <span>{t("organizationPage.assetDiscovery")}</span>
                                                                            <span>{formatNumber(data?.stats?.new_findings?.asset_discovery)}</span>
                                                                        </li>
                                                                        <li className="d-flex justify-content-between">
                                                                            <span>{t("organizationPage.externalDetectedVulnerabilities")}</span>
                                                                            <span>{formatNumber(data?.stats?.new_findings?.external_detected_vulnerabilities)}</span>
                                                                        </li>
                                                                        <li className="d-flex justify-content-between">
                                                                            <span>{t("organizationPage.DarkWeb")}</span>
                                                                            <span>{formatNumber(data?.stats?.new_findings?.darkweb)}</span>
                                                                        </li>
                                                                        <li className="d-flex justify-content-between">
                                                                            <span>{t("organizationPage.concerningExposures")}</span>
                                                                            <span>{formatNumber(data?.stats?.new_findings?.concerning_exposures)}</span>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </motion.div>                                    
                                </Col>
                            )
                        })
                    }
                </>
            }
            <ScanModal show={showStartScanModal} onHide={handleCloseModal} domainData={scanningDomain}/>
            <DeleteScanModal show={showdeleteScanModal} onHide={handleCloseDeleteDomainModal} deleteDomainData={deleteDomainData}/>
        </Row>
    );
};

export default DomainTileView;
